import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import '../global.css';

const ICONS = {
  success: <FaCheckCircle />,
  error: <FaExclamationTriangle />
};

export default function Popup({ message, type = 'success', open }) {
  if (!open) return null;
  return (
    <div className={`popup-notification ${type}`} role="status" aria-live="polite">
      <span className="popup-glow" aria-hidden="true" />
      <span className="popup-icon">{ICONS[type] || <FaCheckCircle />}</span>
      <span className="popup-message">{message}</span>
      {type === 'success' ? (
        <span className="popup-sparkles" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </span>
      ) : null}
      <span className="popup-close" aria-hidden="true">
        <FaTimes />
      </span>
    </div>
  );
}
